import { useState } from "react";
import SectionHead from "./SectionHead";
import { trendingTabs, trendingData } from "@/mocks/homeData";

export default function Trending() {
  const [active, setActive] = useState("today");
  const list = trendingData[active] || [];

  return (
    <section id="trending" className="bg-background-100 py-16 md:py-24" aria-label="热门热议">
      <div className="mx-auto max-w-5xl px-4 md:px-6">
        <SectionHead
          eyebrow="热门热议"
          title="大家都在吃的瓜"
          desc="吧友新鲜投稿与热议内容实时汇聚，从职场内幕到校园趣闻，热搜瓜料一键刷到手软。"
        />

        {/* TAB 切换 */}
        <div className="mx-auto mb-8 flex w-fit items-center gap-1 rounded-full bg-background-200 p-1">
          {trendingTabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActive(tab.key)}
              className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors md:px-6 ${
                active === tab.key
                  ? "bg-primary-500 text-white"
                  : "text-foreground-600 hover:text-foreground-950"
              }`}
            >
              {tab.label}
              {active === tab.key && (
                <i className="ri-check-line text-sm" aria-hidden="true"></i>
              )}
            </button>
          ))}
        </div>

        <div className="flex flex-col gap-3">
          {list.map((item) => (
            <article
              key={`${active}-${item.rank}`}
              className="group flex items-center gap-4 rounded-2xl bg-background-50 p-4 transition-all hover:translate-x-1 md:p-5"
            >
              <span
                className={`font-serifsc w-9 shrink-0 text-center text-3xl font-black ${
                  item.rank === "1"
                    ? "text-primary-500"
                    : item.rank === "2"
                    ? "text-accent-600"
                    : "text-background-300"
                }`}
              >
                {item.rank}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">{item.title}</h3>
                <p className="mt-1 flex flex-wrap items-center gap-x-2 text-xs text-foreground-500">
                  <span>{item.meta}</span>
                </p>
              </div>
              <div className="flex shrink-0 items-center gap-2 md:gap-4">
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                  <i className="ri-fire-fill text-sm" aria-hidden="true"></i>
                  {item.count}
                </span>
                <button
                  type="button"
                  className="hidden whitespace-nowrap rounded-full bg-secondary-100 px-4 py-2 text-xs font-semibold text-secondary-900 transition-colors hover:bg-secondary-200 sm:inline-flex"
                >
                  去围观
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}